import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { CalloutBox } from 'components/Docs/CalloutBox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CalloutBox type="fyi" icon="IconInfo" title="Proxy note" mdxType="CalloutBox">
      <p>{`These SDKs `}<strong parentName="p">{`do not`}</strong>{` proxy your calls. They only fire off an async call to PostHog in the background to send the data.`}</p>
      <p>{`You can also use LLM analytics with other SDKs or our API, but you will need to capture the data in the right format. See the schema in the `}<a parentName="p" {...{
          "href": "/docs/llm-analytics/installation/manual-capture"
        }}>{`manual capture section`}</a>{` for more details.`}</p>
    </CalloutBox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      